import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Box } from "@mui/material";
import { InputField, DatePickerField, SelectField } from "../../FormFields";
import { facultyOption } from "../../../../../_mock_/faculty";

export default function MentorInformation(props) {
  const {
    formField: {
      //page2
      faculty,
      department,
      mobileNumber,
      dateOfBirth
    }
  } = props;

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Mentor Information
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <SelectField
            name={faculty.name}
            label={faculty.label}
            data={facultyOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={department.name}
            label={department.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={mobileNumber.name}
            label={mobileNumber.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePickerField
            name={dateOfBirth.name}
            label={dateOfBirth.label}
            inputFormat="dd/MM/yyyy"
            disableFuture
            inputVariant="outlined"
          />
        </Grid>
      </Grid>
    </>
  );
}
